import React, { useEffect, useState, useCallback } from "react";
import { api, formatDuration, formatDate } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { History, TimerReset } from "lucide-react";

export default function Cronologia() {
  const [scope, setScope] = useState("current");
  const [data, setData] = useState({ shifts: [], total_seconds: 0 });

  const load = useCallback(() => {
    api.get(`/shifts/history?scope=${scope}`).then((r) => setData(r.data)).catch(() => {});
  }, [scope]);

  useEffect(() => { load(); }, [load]);

  const totalH = Math.floor(data.total_seconds / 3600);
  const totalM = Math.floor((data.total_seconds % 3600) / 60);

  return (
    <div className="w-full">
      <PageHeader
        icon={History}
        title="Cronologia Turni di Servizio"
        subtitle={scope === "current" ? "" : "Tutti i turni registrati di sempre."}
        right={
          <div className="flex flex-wrap gap-1 ot-panel p-1">
            {[
              { k: "current", l: "Corrente" },
              { k: "lifetime", l: "Storico" },
            ].map((s) => (
              <button key={s.k} data-testid={`crono-scope-${s.k}`} onClick={() => setScope(s.k)}
                className={`px-3 py-1.5 text-xs ot-heading uppercase tracking-widest rounded transition-colors ${scope === s.k ? "bg-blue-400 text-black" : "text-slate-400 hover:text-blue-400"}`}>
                {s.l}
              </button>
            ))}
          </div>
        }
      />

      <div className="ot-panel p-6 mb-6 flex items-center justify-between ot-fade-up">
        <div>
          <div className="ot-label mb-2">{scope === "current" ? "ORE CICLO CORRENTE" : "ORE TOTALI DI SEMPRE"}</div>
          <div className="flex items-baseline gap-2">
            <span className="ot-mono text-5xl font-black text-blue-400" style={{ textShadow: "0 0 24px rgba(0,229,255,0.4)" }} data-testid="total-hours">
              {String(totalH).padStart(2, "0")}h
            </span>
            <span className="ot-mono text-3xl text-slate-300">{String(totalM).padStart(2, "0")}m</span>
          </div>
        </div>
        <div className="w-14 h-14 rounded border border-blue-400/40 bg-blue-400/5 flex items-center justify-center">
          <TimerReset className="w-6 h-6 text-blue-400" />
        </div>
      </div>

      <div className="ot-panel-elev p-6 ot-fade-up" style={{ animationDelay: "80ms" }}>
        <h2 className="ot-heading text-2xl font-bold text-slate-100 mb-4">Storico Servizi</h2>

        {data.shifts.length === 0 ? (
          <div className="py-16 text-center">
            <History className="w-10 h-10 mx-auto text-slate-600 mb-3" />
            <div className="text-slate-400">
              {scope === "current" ? "Nessun turno nel ciclo corrente." : "Nessun turno registrato."}
            </div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left border-b border-white/5">
                  <th className="ot-label py-3 font-normal">#</th>
                  <th className="ot-label py-3 font-normal">Inizio</th>
                  <th className="ot-label py-3 font-normal">Fine</th>
                  <th className="ot-label py-3 font-normal text-right">Durata</th>
                  <th className="ot-label py-3 font-normal text-right">Stato</th>
                </tr>
              </thead>
              <tbody>
                {data.shifts.map((s, i) => (
                  <tr key={s.id} className="border-b border-white/5 hover:bg-blue-400/[0.02] transition-colors" data-testid={`history-row-${i}`}>
                    <td className="py-3 ot-mono text-slate-500">{String(data.shifts.length - i).padStart(3, "0")}</td>
                    <td className="py-3 text-slate-300">{formatDate(s.start_at)}</td>
                    <td className="py-3 text-slate-300">{formatDate(s.end_at)}</td>
                    <td className="py-3 text-right ot-mono text-blue-400 font-bold">{formatDuration(s.duration_seconds)}</td>
                    <td className="py-3 text-right">
                      {s.paid_at ? (
                        <span className="ot-mono text-[0.6rem] text-emerald-400 tracking-widest border border-emerald-400/40 rounded px-1.5 py-0.5">PAGATO</span>
                      ) : (
                        <span className="ot-mono text-[0.6rem] text-amber-400 tracking-widest border border-amber-400/40 rounded px-1.5 py-0.5">CORRENTE</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
